import React, { PureComponent } from "react"
import { t } from "../../i18next"

export default class PageNotFound extends PureComponent {
  render() {
    return <div className="common-page-not-found">{t("common.errors.pageNotFound")}</div>
  }
}



// WEBPACK FOOTER //
// ./src/features/common/PageNotFound.js